import jsPDF from 'jspdf';
import 'jspdf-autotable';
import moment from 'moment'
import axios from "axios";

import {
  Row
} from 'jspdf-autotable';

import { getBase64ImageFromUrl } from '../utils/urlToBase64'

export const noticeMixin = {
  data: () => ({}),
  methods: {
    downloadAttendanceParent(pars, getBranch, notice) {
      const months = [
        "Enero",
        "Febrero",
        "Marzo",
        "Abril",
        "Mayo",
        "Junio",
        "Julio",
        "Agosto",
        "Septiembre",
        "Octubre",
        "Noviembre",
        "Diciembre"
      ];
      var fechaNoticia = "" +
        (notice.startDate ? new Date(notice.startDate).getDate() + "/" + months[new Date(notice.startDate).getMonth()] + "/" + new Date(notice.startDate).getFullYear() : "") +
        (notice.endDate && notice.endDate ? " - " : "") +
        (notice.endDate ? new Date(notice.endDate).getDate() + "/" + months[new Date(notice.endDate).getMonth()] + "/" + new Date(notice.endDate).getFullYear() : "");

      let fDate =
        new Date().getDate() +
        "/" +
        months[new Date().getMonth()] +
        "/" +
        new Date().getFullYear();

      var data = [];
      for (const [index, item] of pars.entries()) {
        data.push([item.parent.firstName + " " + item.parent.lastName,
          moment(String(new Date(item.date))).format('MM/DD/YYYY hh:mm:ss'),
          item.parent.mail
        ])
      }

      var doc = new jsPDF('p', 'pt', 'letter');
      var v = {
        getBranch
      };
      var header = function (data) {
        var x = 50;
        doc.setFont("helvetica");
        doc.setFontType("bold");
        doc.setFontSize(25);
        doc.text(v.getBranch.name, x, 45);
        doc.setFontSize(18);
        doc.text(notice.title, x, 85);
        doc.setFont("helvetica");
        doc.setFontSize(10);
        doc.text("Reporte de asistencia de papás", x, 98);
        doc.text("Fecha del evento: " + fechaNoticia, x, 110);
        var splitTitle = doc.splitTextToSize(v.getBranch.address, 400);
        var y = 60;
        for (var i in splitTitle) {
          doc.text(splitTitle[i], x, y);
          y += 12;
        }
        doc.setFontSize(8);
        doc.text("Fecha de generación: " + fDate, x, 130);
      };

      doc.autoTable({
        head: [
          ["Nombre", "Hora de asistencia", "Correo"]
        ],
        body: data,
        margin: {
          right: 50,
          left: 50,
          top: 140,
        },
        tableWidth: 500,
        styles: {
          overflow: 'linebreak',
          cellWidth: 'wrap'
        },

        didDrawPage: function (data) {
          if (data.pageNumber == 1) {
            header(data)
          }
        },

        willDrawCell: function (data) {
          data.cell.halign = 'center'
        },

      });

      doc.save("Comunidad-Reporte-Asistencia-Tutores.pdf");
    },
    downloadStudentMasiveQR(students, sizeQr) {
      var bodyArray = []
      for (var p in students) {
        bodyArray.push([
          null,
          students[p].firstName,
          students[p].lastName,
          students[p].level.typeLevel + " " + students[p].gg.grade + "" + students[p].gg.group,
          students[p].personId
        ])
      }
      var images = [];
      var size = sizeQr
      var sizeColsAndRows = size + 20
      var doc = new jsPDF('p', 'pt', 'letter');
      doc.autoTable({
        head: [
          ['QR', 'Nombre', 'Apellidos', 'Grupo', 'Matrícula']
        ],
        body: bodyArray,
        margin: {
          right: 50,
          left: 50
        },
        tableWidth: 500,
        styles: {
          overflow: 'linebreak',
        },
        columnStyles: {
          0: {
            cellWidth: sizeColsAndRows
          }
        },
        willDrawCell: function (data) {
          if (data.section == 'body') {
            data.cell.height = sizeColsAndRows
            data.cell.contentHeight = sizeColsAndRows
            data.cell.halign = 'center'
            data.row.maxCellHeight = sizeColsAndRows
            data.row.height = sizeColsAndRows
          }

        },
        didDrawCell: function (data) {
          console.log(data)
          if (data.column.dataKey == 0 && data.section == 'body') {
            images.push({
              elem: students[data.row.index].qr,
              x: data.cell.textPos.x,
              y: data.cell.textPos.y
            });
          }
        },
        didDrawPage: function () {
          for (var i = 0; i < images.length; i++) {
            if (!images[i].isLoad) {
              doc.addImage(images[i].elem, images[i].x + 10, images[i].y + 5, size, size);
              images[i].isLoad = true;
            }
          }
        }
      });

      doc.save("example.pdf");
    },

    /**
     * @param {*} getBranch 
     * @param {*} notice 
     * @returns 
     * If pdf is Empty returns true else false
     */
    async downloadReportsNotice(getBranch, notice) {

      if (notice.students === undefined && notice.parentsAttendance === undefined)return true

      const tempNoticeParentsAttendance = notice.parentsAttendance || []
      const tempNoticeStudents = notice.students || []

      const isStudentsEmpty = tempNoticeStudents.length === 0
      const isParentsEmpty = tempNoticeParentsAttendance.length === 0

      const months = [
        "Enero",
        "Febrero",
        "Marzo",
        "Abril",
        "Mayo",
        "Junio",
        "Julio",
        "Agosto",
        "Septiembre",
        "Octubre",
        "Noviembre",
        "Diciembre"
      ];
      var fechaNoticia = "" +
        (notice.startDate ? new Date(notice.startDate).getDate() + "/" + months[new Date(notice.startDate).getMonth()] + "/" + new Date(notice.startDate).getFullYear() : "") +
        (notice.endDate && notice.endDate ? " - " : "") +
        (notice.endDate ? new Date(notice.endDate).getDate() + "/" + months[new Date(notice.endDate).getMonth()] + "/" + new Date(notice.endDate).getFullYear() : "");

      let fDate =
        new Date().getDate() +
        "/" +
        months[new Date().getMonth()] +
        "/" +
        new Date().getFullYear();

      var data = [];
      var data2 = [];
      for (const [index, item] of tempNoticeParentsAttendance.entries()) {
        data.push([item.parent.firstName + " " + item.parent.lastName,
          moment(String(new Date(item.date))).format('MM/DD/YYYY hh:mm:ss'),
          item.parent.mail
        ])
      }

      for (const [index, item] of tempNoticeStudents.entries()) {
        var status = "";
        var parnt = "";
        var date = "";
        if (item.noticeConfirm == "P") {
          status = "Pendiente"
        }
        if (item.noticeConfirm == "C") {
          status = "Cancelado"
        }
        if (item.noticeConfirm == "A") {
          status = "Autorizado"
        }
        if (item.noticeConfirmParent && item.noticeConfirmParent.firstName) {
          parnt = item.noticeConfirmParent.firstName + " " + item.noticeConfirmParent.lastName;
          date = moment(String(new Date(item.noticeConfirmDate))).format('MM/DD/YYYY hh:mm:ss');
        }
        data2.push([item.firstName + " " + item.lastName,
          status,
          parnt,
          date
        ])
      }

      var doc = new jsPDF('p', 'pt', 'letter');
      var v = {
        getBranch
      };

      const imagePath = v.getBranch.imageStorage.miniObjUrl
      let imgBase64

      if (isStudentsEmpty === false && isParentsEmpty === false) {
        imgBase64 = await getBase64ImageFromUrl(v.getBranch.imageStorage.miniObjUrl)
      }

      var header = function (data) {
        // doc.setFont("helvetica");
        // doc.setFontType("bold");
        // doc.setFontSize(25);
        doc.text(v.getBranch.name, 160, 45);
        // doc.setFontSize(18);
        doc.text(notice.title, 160, 85);
        // doc.setFont("helvetica");
        // doc.setFontSize(13);
        doc.text("Reporte de asistencia de papás", 160, 98);
        // doc.setFontSize(10);
        doc.text("Fecha del evento: " + fechaNoticia, 160, 110);
        var splitTitle = doc.splitTextToSize(v.getBranch.address, 400);
        var y = 60;
        for (var i in splitTitle) {
          doc.text(splitTitle[i], 160, y);
          y += 12;
        }
        doc.setFontSize(8);
        doc.text("Fecha de generación: " + fDate, 160, 130);
        if (imagePath != null && imagePath != "") {
          doc.addImage(
            imgBase64,
            "JPEG",
            data.settings.margin.left,
            25,
            100,
            100
          ); //(imagen,formato,x-pos,y-pos, width,heigth)
        }
      };

      var header2 = function (data) {
        // doc.setFont("helvetica");
        // doc.setFontType("bold");
        // doc.setFontSize(25);
        doc.text(v.getBranch.name, 160, 45);
        // doc.setFontSize(18);
        doc.text(notice.title, 160, 85);
        // doc.setFont("helvetica");
        // doc.setFontSize(13);
        doc.text("Reporte de confirmación de alumnos", 160, 98);
        // doc.setFontSize(10);
        doc.text("Fecha del evento: " + fechaNoticia, 160, 110);
        var splitTitle = doc.splitTextToSize(v.getBranch.address, 400);
        var y = 60;
        for (var i in splitTitle) {
          doc.text(splitTitle[i], 160, y);
          y += 12;
        }
        // doc.setFontSize(8);
        doc.text("Fecha de generación: " + fDate, 160, 130);
        if (v.getBranch.img != null && v.getBranch.img != "") {
          var imgData = v.getBranch.img
          doc.addImage(
            imgData,
            "JPEG",
            data.settings.margin.left,
            25,
            100,
            100
          ); //(imagen,formato,x-pos,y-pos, width,heigth)
        }
      };

      if (isParentsEmpty === false) {
        doc.autoTable({
  
          head: [
            ["Nombre", "Hora de asistencia", "Correo"]
          ],
  
          body: data,
          margin: {
            right: 50,
            left: 50,
            top: 140,
          },
          tableWidth: 500,
          styles: {
            overflow: 'linebreak',
            cellWidth: 'wrap'
          },
  
          didDrawPage: function (data) {
            if (data.pageNumber == 1)
              header(data)
          },
  
          willDrawCell: function (data) {
            data.cell.halign = 'center'
  
          },
  
        });
        doc.addPage();
      }
      if (isStudentsEmpty === false) {
        doc.autoTable({
  
          head: [
            ["Alumno", "Estado", "Tutor que confirmo", "Fecha de autorización"]
          ],
  
          body: data2,
          margin: {
            right: 50,
            left: 50,
            top: 140,
          },
          tableWidth: 500,
          styles: {
            overflow: 'linebreak',
            cellWidth: 'wrap'
          },
  
          didDrawPage: function (data) {
            if (data.pageNumber == 1)
              header2(data)
          },
  
          willDrawCell: function (data) {
            data.cell.halign = 'center'
  
          },
  
        });
      }

      if (isStudentsEmpty === false || isParentsEmpty === false) {
        doc.save("example.pdf");
      }

      return (isStudentsEmpty && isParentsEmpty)
    },
    downloadAttendanceStudent(pars, getBranch, notice) {
      const months = [
        "Enero",
        "Febrero",
        "Marzo",
        "Abril",
        "Mayo",
        "Junio",
        "Julio",
        "Agosto",
        "Septiembre",
        "Octubre",
        "Noviembre",
        "Diciembre"
      ];
      var fechaNoticia = "" +
        (notice.startDate ? new Date(notice.startDate).getDate() + "/" + months[new Date(notice.startDate).getMonth()] + "/" + new Date(notice.startDate).getFullYear() : "") +
        (notice.endDate && notice.endDate ? " - " : "") +
        (notice.endDate ? new Date(notice.endDate).getDate() + "/" + months[new Date(notice.endDate).getMonth()] + "/" + new Date(notice.endDate).getFullYear() : "");
  
      let fDate =
        new Date().getDate() +
        "/" +
        months[new Date().getMonth()] +
        "/" +
        new Date().getFullYear();
  
      var data = [];
      for (const [index, item] of pars.entries()) {
        data.push([item.student.firstName + " " + item.student.lastName,
          moment(String(new Date(item.date))).format('MM/DD/YYYY hh:mm:ss')
        ])
      }
  
      var doc = new jsPDF('p', 'pt', 'letter');
      var v = {
        getBranch
      };
      var header = function (data) {
        var x = 50;
        doc.setFont("helvetica");
        doc.setFontType("bold");
        doc.setFontSize(25);
        doc.text(v.getBranch.name, x, 45);
        doc.setFontSize(18);
        doc.text(notice.title, x, 85);
        doc.setFont("helvetica");
        doc.setFontSize(10);
        doc.text("Reporte de asistencia de estudiantes", x, 98);
        doc.text("Fecha del evento: " + fechaNoticia, x, 110);
        var splitTitle = doc.splitTextToSize(v.getBranch.address, 400);
        var y = 60;
        for (var i in splitTitle) {
          doc.text(splitTitle[i], x, y);
          y += 12;
        }
        doc.setFontSize(8);
        doc.text("Fecha de generación: " + fDate, x, 130);
      };
  
      doc.autoTable({
        head: [
          ["Nombre", "Hora de asistencia"]
        ],
        body: data,
        margin: {
          right: 50,
          left: 50,
          top: 140,
        },
        tableWidth: 500,
        styles: {
          overflow: 'linebreak',
          cellWidth: 'wrap'
        },
  
        didDrawPage: function (data) {
          if (data.pageNumber == 1) {
            header(data)
          }
        },
  
        willDrawCell: function (data) {
          data.cell.halign = 'center'
        },
  
      });
  
      doc.save("Comunidad-Reporte-Asistencia-Alumnos.pdf");
    },
  }
}